// Import calculations
import { LivestockDrinkingRequirementCalc } from '../Calculations/Use/LivestockDrinkingRequirementCalc';
import { HouseholdWaterUseCalc } from '../Calculations/Use/HouseholdWaterUseCalc';
import { GardenWaterUseCalc, DairyShedWaterUseCalc } from '../Calculations/Use/GardenAndShedWaterUseCalc';
import { OtherWaterUseCalc } from '../Calculations/Use/OtherWaterUseCalc';
import { UpdateTotalOnFarmWaterUse } from '../Calculations/Use/TotalOnFarmWaterUse';
import { PotentialCatchmentCalc } from '../Calculations/Supply/PotentialCatchmentCalc';
import { UpdateWaterSupplyTotal } from '../Calculations/Supply/WaterSupplyTotal';
import { TankVolumeCalc } from '../Calculations/Storage/TankVolumeCalc';
import { DamVolumeCalc } from '../Calculations/Storage/DamVolumeCalc';
import { GroundwaterCreeksRiversCalc } from '../Calculations/Supply/GroundwaterCreeksRiversCalc';
import { RoofSurfaceCalc } from '../Calculations/Supply/RoofSurfaceCalc';

/**
 * Bind the calculations to the relevant fields. This function is the central
 * controller that dishes out the calculations according to the ID string we
 * are provided.
 * 
 * @param   {object}    fieldData
 * @param   {string}    id
 * 
 * @returns {null|integer}
 */
export const calculationsController = (fieldData, id) => {
    if (fieldData && id) {
        const fields = DatasetIDs.find(item => item.name === id);

        if (fields) {
            fields?.primaryFunction(id, fieldData);

            if (fields.secondaryFunction !== null) {
                fields.secondaryFunction(id, fieldData);
            }
        } else {
            console.warn('No match found', id, fields, fieldData);
        }
    }
};

// This is where we save the callbacks to run the functions, based off
// the identifiers we have set in place at the top level accordion.
const DatasetIDs = [
    {
        name: 'potential-catchment-supply',
        primaryFunction: PotentialCatchmentCalc,
        secondaryFunction: null
    },
    {
        name: 'livestock-drinking-requirements',
        primaryFunction: LivestockDrinkingRequirementCalc,
        secondaryFunction: null
    },
    {
        name: 'household-garden-dairy-shed',
        primaryFunction: GardenWaterUseCalc,
        secondaryFunction: DairyShedWaterUseCalc
    }
];

// Call all other calculations. Give it a couple of seconds to
// allow all other components to mount.
window.addEventListener('load', () => {
    setTimeout(() => {
        // Use Section
        HouseholdWaterUseCalc();
        OtherWaterUseCalc(false);
        UpdateTotalOnFarmWaterUse();

        // Supply Section
        GroundwaterCreeksRiversCalc(false);
        RoofSurfaceCalc(false);
        UpdateWaterSupplyTotal();

        // Storage section
        TankVolumeCalc(false);
        DamVolumeCalc(false);
    }, 2000);
});
